'use client';
import { createContext, useContext } from 'react';
const NavContext = createContext(null);
function useNav() {
    const value = useContext(NavContext);
    if (!value) {
        throw new Error('useNav must be used inside <NavProvider>');
    }
    return value;
}
export { NavContext, useNav };
//# sourceMappingURL=context.js.map